import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeMode, ThemeState } from '@packages/global';

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({ mode: 'light', setMode: (mode) => set({ mode }) }),
    { name: 'theme-storage' }
  )
);
